/**
 * This patch fixes corrupt detail page links inside Rich Text elements.
 */
import _ from 'lodash';
import type {Context} from '../types';

// Inline util to check types of links from when this patch was introduced
const isLinkPage = function (data: any): boolean {
  return Boolean(data && data.link && data.link.mode === 'page');
};

export default (context: Context) => {
  const {
    node: {
      jsonNode: {data: nodeData = {}, _id},
    },
    extraContext: {collections = {}},
  } = context;

  const isPageLink = isLinkPage(nodeData);
  const isDetailPageLink =
    isPageLink && nodeData.link.itemId && nodeData.link.collectionId;
  const href =
    isDetailPageLink && nodeData && nodeData.attr && nodeData.attr.href;
  const splitHref = typeof href === 'string' && href.split('/');
  const collectionSlug = splitHref && splitHref[1];
  const primaryLookupCollection =
    isDetailPageLink && collections[nodeData.link.collectionId];
  const fallbackLookupCollection =
    !primaryLookupCollection &&
    collectionSlug &&
    _.find(collections, {slug: collectionSlug});

  return {
    needed: Boolean(fallbackLookupCollection),
    logData: {
      msg: 'Detail page link inside Rich Text element has a corrupt collection id',
      meta: {
        nodeId: _id,
      },
    },
    apply: () => {
      // This is already checked in `needed` above but we need this for Flow type check to pass.
      if (fallbackLookupCollection && fallbackLookupCollection._id) {
        nodeData.link.collectionId = fallbackLookupCollection._id;
      }
    },
  };
};
